var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.168 1.292a6.875 6.875 0 1 0 0 13.75 6.875 6.875 0 0 0 0-13.75ZM.043 8.165a8.125 8.125 0 1 1 16.25 0 8.125 8.125 0 0 1-16.25 0ZM15.96 13.975c-.64-.005-1.217.248-1.57.736-.351.489-.41 1.117-.209 1.726.252.76.744 1.41 1.498 1.511.755.101 1.4-.396 1.841-1.06.42-.633.598-1.375.257-2.013-.341-.636-1.057-.9-1.816-.9Zm-.592 2.07c.19.574.424.657.477.664.054.008.3-.012.634-.513m-1.11-.15c-.1-.3-.042-.496.036-.604.077-.106.24-.22.548-.217h.005c.523 0 .681.174.717.24.036.067.093.296-.196.73"
  }))));
};
export default SvgSearch;